import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import SideRegulationInformation from 'containers/CourtManagerLegalProceedings/Provision/Regulation/SideRecap/SideRegulationInformation';
import SahamAccordion from 'components/SahamAccordion';
import { useState } from 'react';
import {
  expandSideRegulation,
  getRisks,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import SideRegulationVictimDetails from 'containers/CourtManagerLegalProceedings/Provision/Regulation/SideRecap/SideRegulationVictimDetails';
import { ClaimRecapType } from 'typings/claimTypes';

export interface SideRegulationDetailsProps {
  intl: IntlShape;
  sagisClaim: any;
  claimRecap: ClaimRecapType;
  riskRecap: any;
  listings: Listings;
  substituteDocumentNature: any;
  showRegulationJudgement: boolean;
  height: number;
  risk: any;
  isBasicManagementRegulation?: boolean;
}

export const SideRegulationDetails: React.FC<SideRegulationDetailsProps> = ({
  sagisClaim,
  claimRecap,
  riskRecap,
  listings,
  substituteDocumentNature,
  showRegulationJudgement,
  height,
  risk,
  ...props
}): JSX.Element => {
  const { rcCorpo, rcMaterial, additionalWarrenties } = getRisks(riskRecap);

  const [expanded, setExpanded] = useState({
    ...expandSideRegulation(rcCorpo, riskRecap),
    ...expandSideRegulation(rcMaterial, riskRecap),
    ...expandSideRegulation(additionalWarrenties, riskRecap),
  });
  const handleChangeExpanded = (item: any) => (
    event: React.ChangeEvent<{}>,
  ) => {
    const expandedRisks = { ...expanded } as any;
    expandedRisks[item.regulationId] = !expanded[item.regulationId];

    setExpanded(expandedRisks);
  };
  return (
    <SahamAccordion
      key={risk.regulationId}
      title={risk['riskName']}
      expanded={expanded[risk.regulationId]}
      onChange={handleChangeExpanded(risk)}
    >
      <>
        <SideRegulationVictimDetails
          height={height}
          sagisClaim={sagisClaim}
          claimRecap={claimRecap}
          riskRecap={riskRecap}
          substituteDocumentNature={substituteDocumentNature}
          listings={listings}
          showRegulationJudgement={showRegulationJudgement}
          risk={risk}
        />

        {showRegulationJudgement && (
          <SideRegulationInformation
            risk={risk}
            listings={listings}
            substituteDocumentNature={substituteDocumentNature}
            showRegulationJudgement={showRegulationJudgement}
            isBasicManagementRegulation={props.isBasicManagementRegulation}
          />
        )}
      </>
    </SahamAccordion>
  );
};

export default injectIntl(SideRegulationDetails);
